"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileListTools = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var ResponsiveButtonBar_1 = require("components/ResponsiveButtonBar");
var translate_1 = require("utils/translate");
var download_1 = require("utils/download");
var Types = require("types");
var mapStateToProps = function (state) {
    return {
        token: state.auth.current.token,
        filesData: state.files.data,
        selectedItems: state.files.selectedItems,
        currentProject: state.project.currentProject,
        sortByOptions: state.files.sortByOptions,
        currentFolder: state.files.currentFolder,
        currentBid: state.bid.current.bid,
        data: state.files.data,
        selectedLanguage: (0, translate_1.getLanguage)()
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    downloadFiles: function (files, token) { return function () {
        if (files.length > 1 ||
            files.filter(function (f) { return f.type === 'FOLDER'; }).length > 0) {
            var retVal = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/download/loading-title'), (0, translation_1.getLocalization)('files/toast/download/loading-text'), 'NORMAL', [], undefined, 0));
            var uuid_1 = retVal.payload.uuid;
            (0, download_1.downloadFiles)(token, files, undefined, undefined, function () { return dispatch(ToastActions.removeToast(uuid_1)); }, { includeSubFolders: 'true', includeSelf: 'true' });
            return;
        }
        window.open(__UPLOADSERVERURL__ + '/files/' + files[0].uuid, '_blank');
    }; },
    toggleFileReportModal: function () {
        dispatch(FilesActions.toggleFileReportModal());
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), recompose_1.pure);
exports.FileListTools = enhance(function (props) {
    if (props.isMobile) {
        return (React.createElement(ResponsiveButtonBar_1.ResponsiveButtonBar, { verticalButtonLayout: true, forceMobileStyle: true },
            React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/download'), disabled: props.selectedItems.length === 0, color: "dark-gray", onClick: props.downloadFiles(props.selectedItems, props.token), icon: React.createElement(sok_ui_1.Icon, { className: "fa-cloud-download" }) }),
            React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/fileReport'), onClick: props.toggleFileReportModal, icon: React.createElement(sok_ui_1.Icon, { className: "fas fa-file-excel" }), color: "gray" })));
    }
    return (React.createElement(sok_ui_1.ToolsSidebarWrap, { className: 'files-view-tools-container' },
        React.createElement(sok_ui_1.ToolsSidebar, { className: 'file-list-tools', headerText: (0, translation_1.getLocalization)('userfront/project/fileListTools') },
            React.createElement(sok_ui_1.ToolButton, { text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/download'), disabled: props.selectedItems.length === 0, color: 'blue', onClick: props.downloadFiles(props.selectedItems, props.token), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-cloud-download' }) }),
            React.createElement(sok_ui_1.ToolButton, { onClick: props.toggleFileReportModal, text: (0, translation_1.getLocalization)('userfront/project/fileListTools/buttons/fileReport'), icon: React.createElement(sok_ui_1.Icon, { className: "fas fa-file-excel" }), color: "gray" }))));
});
